module.exports = __webpack_public_path__ + "img/genie.94809355.png";